import { Input, Label, Select } from "@woodmac-hycb/form-input";
import { Col, Row } from "@woodmac-hycb/layout";

function OutputChangeAlert({ setChange, setChangeType, setSampleType, setSampleHours, setIgnore, outputChangeAlert }) {

    const changeTypes = ['Megawatt', 'Percent'];

    const sampleTypes = ['Mean', 'Median', 'Output'];

    return (
        <Col gap={16}>
            <Col gap={8}>
                <Row gap={8} className="alert-def-input">
                    <Label>Change</Label>
                    <Input type="text" onChange={e => setChange(e.target.value)} value={outputChangeAlert.change ?? ''} />
                </Row>
            </Col>
            <Col gap={8}>
                <Row gap={8} className="alert-def-input">
                    <Label>Type of Change</Label>
                    <Select onChange={e => setChangeType(e.target.value)} value={outputChangeAlert ? outputChangeAlert.changeType : changeTypes[0]}>
                        {changeTypes.map((changeType, index) => (
                            <option key={index} value={changeType}>{changeType}</option>
                        ))}
                    </Select>
                </Row>
            </Col>
            <Col gap={8}>
                <Row gap={8} className="alert-def-input">
                    <Label>Type of Sample</Label>
                    <Select onChange={e => setSampleType(e.target.value)} value={outputChangeAlert ? outputChangeAlert.sampleType : sampleTypes[0]}>
                        {sampleTypes.map((sampleType, index) => (
                            <option key={index} value={sampleType}>{sampleType}</option>
                        ))}
                    </Select>
                </Row>
            </Col>
            <Col gap={8}>
                <Row gap={8} className="alert-def-input">
                    <Label># of Hours to Sample</Label>
                    <Input type="text" onChange={e => setSampleHours(e.target.value)} value={outputChangeAlert.hoursToSample ?? ''} />
                </Row>
            </Col>
            <Col gap={8}>
                <Row gap={8} className="alert-def-input">
                    <Label>Ignore Above</Label>
                    <Input type="text" onChange={e => setIgnore(e.target.value, 'up')} value={outputChangeAlert.ignoreAbove ?? ''} />
                </Row>
            </Col>
            <Col gap={8}>
                <Row gap={8} className="alert-def-input">
                    <Label>Ignore Below</Label>
                    <Input type="text" onChange={e => setIgnore(e.target.value, 'down')} value={outputChangeAlert.ignoreBelow ?? ''} />
                </Row>
            </Col>
        </Col>
    )
}

export default OutputChangeAlert;